<ng-container *ngIf="status || canvasData.length <= 0">
  <button
    class="close modalClose"
    mat-button
    (click)="onNoClick()"
    tabindex="-1"
  >
    X
  </button>
</ng-container>

<h3 mat-dialog-title>{{ message }}</h3>

<div mat-dialog-content>
  <div [hidden]="dataSource && canvasData.length > 0" class="noItems">
    No canvases available to be published
  </div>

  <div [hidden]="dataSource && canvasData.length <= 0">
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      id="dataTable"
      style="max-height: 200px !important"
    >
      <!-- canvasName Column -->
      <ng-container matColumnDef="canvasName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="canvasName">
          Canvas Name
        </th>
        <td mat-cell *matCellDef="let element">{{ element.canvasName }}</td>
      </ng-container>

      <ng-container *ngIf="!status">
        <!-- categoryName Column -->
        <ng-container matColumnDef="categoryName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="categoryName">
            Category
          </th>
          <td mat-cell *matCellDef="let element">{{ element.categoryName }}</td>
        </ng-container>

        <!-- buildName Column -->
        <ng-container matColumnDef="buildName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="buildName">
            Build
          </th>
          <td mat-cell *matCellDef="let element">{{ element.buildName }}</td>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="status">
        <!-- status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="status">
            Status
          </th>
          <td mat-cell *matCellDef="let element">
            <span
              [ngClass]="{
                'import-failed': element.status == 'Failed',
                'import-success': element.status == 'Success',
              }
            "
              >{{ element.status }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="error">
          <th mat-header-cell *matHeaderCellDef>Error Message</th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.error }} </span>
          </td>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 50, 100, 500]"
      showFirstLastButtons="true"
    ></mat-paginator>
  </div>
</div>
<div mat-dialog-actions>
  <ng-container *ngIf="!status">
    <button mat-button mat-dialog-close class="button_small cancel">
      cancel
    </button>
    <button
      mat-button
      class="button_small"
      (click)="onConfirmClick()"
      [disabled]="canvasData.length <= 0"
    >
      {{ actionButton }}
    </button>
  </ng-container>
</div>
